// components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { clearSession, getStoredUser, isAuthenticated } from "../utils/authSession";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    if (getStoredUser()) clearSession();
    const next = `${location.pathname}${location.search || ""}`;
    const to = next && next !== "/" ? `/login?next=${encodeURIComponent(next)}` : "/login";
    return <Navigate to={to} replace />;
  }
  return children;
}
